import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { LoginTracking } from '@mira-avant/mtlibs';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root',
})
export class LoginTrackingService {
	private readonly BASE_PATH = 'loginTracking';

	constructor(private api: ApiService) {}

	/**
	 * Get the last 100 logins for a specific user
	 * Regular users can only view their own login history
	 * Admins can view any user's login history
	 *
	 * @param cognitoUserUuid The UUID of the user to get login history for
	 * @returns A promise that resolves to an array of LoginTracking objects
	 */
	public async getLastLoginsByUser$(cognitoUserUuid: string): Promise<LoginTracking[]> {
		return firstValueFrom(
			this.api.get<LoginTracking[]>(`${this.BASE_PATH}/user/${cognitoUserUuid}`)
		);
	}

	/**
	 * Get the last 100 logins for a specific client
	 * Only accessible by admin users
	 *
	 * @param clientUuid The UUID of the client to get login history for
	 * @returns A promise that resolves to an array of LoginTracking objects
	 */
	public async getLastLoginsByClient$(clientUuid: string): Promise<LoginTracking[]> {
		return firstValueFrom(
			this.api.get<LoginTracking[]>(`${this.BASE_PATH}/client/${clientUuid}`)
		);
	}
}
